import React from 'react'

export default function FirstMonthSeperator() {
  return (
	<div className="first-month-seperator-content --no-fill">
		<div className="first-month-seperator-content-line"></div>
		<svg className="first-month-seperator-content-svg"width="84" height="22" viewBox="0 0 84 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M81 3L66.9436 11.8503C58.4871 17.1748 48.6976 20 38.7045 20H32.5H2" stroke="url(#paint0_linear_27_2)" strokeWidth="3" strokeLinecap="square"/>
			<defs>
				<linearGradient id="paint0_linear_27_2" x1="50.5" y1="19.9993" x2="-819" y2="-229.501" gradientUnits="userSpaceOnUse">
					<stop stopColor="white" stopOpacity="0.2"/>
					<stop offset="1" stopColor="white" stopOpacity="0"/>
				</linearGradient>
			</defs>
		</svg>
	</div>
  )
}
